/**
 * Project Contact Section Component
 */

import { User, Mail, Phone, UserCog } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface ProjectContactSectionProps {
  contactName?: string;
  contactEmail?: string;
  contactPhone?: string;
  accountManagerName?: string;
}

export function ProjectContactSection({
  contactName,
  contactEmail,
  contactPhone,
  accountManagerName,
}: ProjectContactSectionProps) {
  const hasContact = contactName || contactEmail || contactPhone;

  if (!hasContact && !accountManagerName) {
    return null;
  }

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base">Contact</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {contactName && (
          <div className="flex items-center gap-2 text-sm">
            <User className="h-4 w-4 text-muted-foreground" />
            <span>{contactName}</span>
          </div>
        )}
        {contactEmail && (
          <div className="flex items-center gap-2 text-sm">
            <Mail className="h-4 w-4 text-muted-foreground" />
            <a href={`mailto:${contactEmail}`} className="text-blue-600 hover:underline">
              {contactEmail}
            </a>
          </div>
        )}
        {contactPhone && (
          <div className="flex items-center gap-2 text-sm">
            <Phone className="h-4 w-4 text-muted-foreground" />
            <a href={`tel:${contactPhone}`} className="hover:underline">
              {contactPhone}
            </a>
          </div>
        )}
        {accountManagerName && (
          <div className="flex items-center gap-2 text-sm pt-2 border-t">
            <UserCog className="h-4 w-4 text-muted-foreground" />
            <span className="text-muted-foreground">Account Manager:</span>
            <span>{accountManagerName}</span>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
